import UserCertificateHistoryOperations from './UserCertificateHistoryOperations'

export default UserCertificateHistoryOperations
